import { BaseClient } from '@/clients/BaseClient';
import { defineStore } from "pinia";
import { useTermsStore } from "@/stores/TermsStore";
import config from "@/composables/Config";
import {getToken, clearToken} from "@/Helper";

export const useBaseStore = defineStore('base', {
    state: () => ({
        token: getToken(),
        initialized: false,
        loading: false,
        user: null,
        brand: null,
        language: null,
        terminology: null,
        languages: null,
    }),

    getters: {
        authenticated(state) {
            return state.token && state.user;
        },
        access(state) {
            return state.initialized
        },
        currentUser(state) {
            return state.user;
        },
        currentLanguage(state) {
            return state.language
        },
        allLanguages(state) {
            return state.languages
        },
        currentBrand(state) {
            return state.brand;
        }
    },

    actions: {
        async loginUser(token) {
            return await this.init(token)
        },
        setLoadingState(loadingState) {
            this.loading = loadingState;
        },
        async init(token) {
            if (token) {
                this.setToken(token)
            }

            if (!this.token) {
                return false;
            }

            if (this.initialized) {
                return true;
            }

            let response;
            try {
                response = await BaseClient.init();
            }
            catch (err) {
                clearToken();
                return false;
            }

            this.user = response.data.user;
            this.brand = response.data.brand;
            this.terminology = response.data.terminology;
            this.languages = response.data.languages;
            this.language = response.data.user.language;
            this.initialized = true

            this.setTerminology();

            return true;
        },

        setCurrentLanguage() {
            this.language = config.default_language;
        },

        setToken(token) {
            this.token = token;
        },

        async setTerminology() {
            const termsStore = useTermsStore();
            const terms = JSON.stringify(this.terminology);
            await localStorage.setItem('terms', terms);
            termsStore.$patch((state) => {
                state.terms = terms
            });
        },

        async setLanguage(code) {
            let response = await BaseClient.userLanguage(code);
            this.language = response.data;
        }
    },
})

